import { Weapon, type WeaponConfig } from './Weapon';

const SNIPER_CONFIG: WeaponConfig = {
  id: 'sniper',
  name: 'Снайперка',
  // economy W12, calibrated to budget=30+10L
  price: 3200,
  fireRateMs: 700,
  bulletsPerShot: 1,
  spreadDeg: 0,
  soundKey: 'pistol_shot',
  soundVolume: 0.6,
  shakeShoot: { intensity: 0.012, duration: 200 },
  magazineSize: 5,
  reloadTimeMs: 4000,
  fireMode: 'single',
  bulletWidth: 16,
  bulletHeight: 4,
  bulletSpeed: 6384,
  recoilForce: 18,
  damage: 25,
};

export function createSniper(): Weapon {
  return new Weapon(SNIPER_CONFIG);
}
